'use strict';

const validateVarient = require('./validateVarient');
const clientSideValidation = require('../components/clientSideValidation');

module.exports = {
    init: function () {
        const $document = $(document);
        const $body = $('body');

        // Handles click on boutique trigger button
        $document.on('click', '.notify-me-link', function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            const $this = $(this);

            const target = e.target;
            let formError = false;
            if ($this.hasClass('veirfy-variation')) {
                formError = validateVarient.validate($this, target);
            }
            if (!formError) {
                let pid = $this.data('pid');
                if ($this.hasClass('notify-me-link-pdp')) {
                    pid = $('.product-detail').first().data('pid');
                }
                if (pid) {
                    let rawQueryString = $this.data('queryString') || '';
                    const $sizeVariation = $this.closest('.attribute-item').find('[data-attr-value]');
                    if ($sizeVariation.length) {
                        const variationURL = $sizeVariation.attr('value');
                        if (variationURL && variationURL.indexOf('?') !== -1) {
                            rawQueryString = variationURL.split('?')[1];
                        }
                    }
                    let params = new URLSearchParams({ pid: pid });
                    if (rawQueryString) {
                        params = new URLSearchParams(rawQueryString);
                    }
                    params.set('isPDP', 'true');
                    const requestUrl = `${$this.data('action')}?${params.toString()}`;
                    // Load boutique overlay only once unless product attribute changes
                    $body.addClass('pdp-partial-loading');
                    $this.closest('#sliter-attribute-size').find('.slider-close').click();
                    $.spinner().start();
                    $.ajax({
                        url: requestUrl,
                        type: 'get',
                        success: function (result) {
                            // Show or hide error text based on result
                            const $errorEle = $this.parent().find('.notify-error-text');
                            $errorEle.text(result.message).toggleClass('d-block', result.error);
                            if (result.error) {
                                validateVarient.validate($this, target);
                            } else {
                                // Remove any existing slider before appending new one
                                $('#notify-me-overlay-slider').remove();
                                // Append rendered HTML from server
                                $body.append($.parseHTML(result.renderedTemplate));
                                // Trigger custom select UI init
                                $document.trigger('customSelectInit');
                                $('.quickview-wrapper').modal('hide');
                                // Open the boutique slider
                                $document.trigger('openSlider', {
                                    target: '#notify-me-overlay-slider',
                                });
                                $this.addClass('notify-me-open');
                            }
                            $.spinner().stop();
                            $body.removeClass('pdp-partial-loading');
                        },
                    });
                }
            }
        });

        $document.on('input', '.notify-me-form', function () {
            const $this = $(this);
            const isToggleDisable = $(this).data('toggleDisable');
            if (isToggleDisable) {
                const validForm = clientSideValidation.functions.validateForm($this.get(0));
                $this.find('.notify-me-submit').prop('disabled', !validForm);
            }
        });

        // Handle reservation form submission
        $document.on('click', '.notify-me-submit', function (e) {
            e.preventDefault();
            const $this = $(this);
            const $thisForm = $this.closest('form');
            const $thisWrapper = $this.closest('.notify-me-slider-wrapper');
            let pid = $thisWrapper.find('.custom-product-card').data('pid');
            // Validate form using imported client-side validation
            const validForm = clientSideValidation.functions.validateForm($thisForm.get(0));
            if (validForm && pid) {
                $thisWrapper.spinner().start();
                // Serialize form fields to object
                const formArray = $thisForm.serializeArray();
                const formDataObj = {};
                formArray.forEach(function (item) {
                    formDataObj[item.name] = item.value;
                });
                formDataObj.pid = pid;
                $.ajax({
                    url: $thisForm.attr('action'),
                    type: 'post',
                    data: formDataObj,
                    success: function (data) {
                        $thisWrapper.spinner().stop();
                        if ('datalayer' in data && data.datalayer) {
                            $body.trigger('gtm:add:event', data);
                        }
                        $('.notify-me-open [type="checkbox"]').prop('checked', true);
                        $('.notify-me-link').removeClass('notify-me-open');
                        $this.closest('.notify-me-overlay').addClass('notify-me-overlay-success');
                        $thisWrapper.html($(data.notifySuccessHtml).find('.notify-me-slider-wrapper').html());
                    },
                });
            }
        });
    },
};
